import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { useTranslation } from "react-i18next";

export default function PresentationScroller() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [currentSlide, setCurrentSlide] = useState(1);
  const numSlides = 10;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((current) => (current === numSlides ? 1 : current + 1));
    }, 7000);
    return () => clearInterval(interval);
  }, []);
  // const prevSlide = () => {
  //   setCurrentSlide((current) => (current === 1 ? numSlides + 1 : current - 1));
  // };
  const nextSlide = () => {
    setCurrentSlide((current) => (current === numSlides ? 1 : current + 1));
  };
  return (
    <>
      <Seo
        title="Dusha Beach Gallery"
        description="A slideshow presentation of Dusha Beach Restaurant."
        pathname={location.pathname}
        lang={lang}
      />
      <div
        style={{
          position: "relative",
          maxWidth: "100%",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        <img
          onClick={nextSlide}
          alt={currentSlide}
          src={`/slides/${lang}/${currentSlide}.jpeg`}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
    </>
  );
}
